// These tokens are either incorrectly priced or have some other issues that spoil the query data
// None of them present any interest as they have almost 0 daily trade volume

export const BSC_TOKEN_WHITELIST = [
    '0x229c32460c6beac113e720ac4a7495b57f53f7cf',
    '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c'
]
export const BSC_TOKEN_BLACKLIST = []